module.exports = __webpack_public_path__ + "static/media/empty woman.4a362545.png";